module.exports = __webpack_public_path__ + "img/FR16218.5f53214f.png";